module.exports = __webpack_public_path__ + "dfbed93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_done@2x.png
// module id = 1244
// module chunks = 0